import {
  between, maxLength, required, requiredIf,
} from 'vuelidate/lib/validators';
import {
  isBetween as dateTimeIsBetween,
  isGreaterOrEqual,
} from '@/services/dateTime/datetimeService';

const validateInstallationDate = (dates, dateValue) => {
  const { installationDate } = dates;
  return isGreaterOrEqual(dateValue, installationDate);
};

const situation = () => ({
  required,
});

const description = fields => ({
  required,
  maxLength: maxLength(fields.description.maxLength),
});

const associatedContact = () => ({
  required,
});

const advanceNoticeMaintenance = fields => ({
  required,
  between: between(
    fields.advanceNoticeMaintenance.minValue,
    fields.advanceNoticeMaintenance.maxValue,
  ),
});

const operatingTimeMaintenance = fields => ({
  required,
  between: between(
    fields.operatingTimeMaintenance.minValue,
    fields.operatingTimeMaintenance.maxValue,
  ),
});

const installationDate = fields => ({
  required,
  between: dateTimeIsBetween(
    fields.installationDate.minValue,
    fields.installationDate.maxValue,
  ),
});

const operationEntryDate = (fields, dates) => ({
  required,
  between: dateTimeIsBetween(
    fields.operationEntryDate.minValue,
    fields.operationEntryDate.maxValue,
  ),
  minDate: () => validateInstallationDate(dates, dates.operationEntryDate),
});

const lastMaintenanceDate = (fields, dates) => ({
  requiredIf: requiredIf(() => fields.lastMaintenanceDate.required),
  between: dateTimeIsBetween(
    fields.lastMaintenanceDate.minValue,
    fields.lastMaintenanceDate.maxValue,
  ),
  minDate: () => validateInstallationDate(dates, dates.lastMaintenanceDate),
});

const totalOperationTime = fields => ({
  requiredIf: requiredIf(() => fields.totalOperationTime.required),
  between: between(
    fields.totalOperationTime.minValue,
    fields.totalOperationTime.maxValue,
  ),
});

const timeSinceLastMaintenance = fields => ({
  requiredIf: requiredIf(() => fields.timeSinceLastMaintenance.required),
  between: between(
    fields.timeSinceLastMaintenance.minValue,
    fields.timeSinceLastMaintenance.maxValue,
  ),
});

const performedMaintenanceAmount = fields => ({
  requiredIf: requiredIf(() => fields.performedMaintenanceAmount.required),
  between: between(
    fields.performedMaintenanceAmount.minValue,
    fields.performedMaintenanceAmount.maxValue,
  ),
});

export default (isUpdating, fields, dates) => {
  const commonValidations = {
    description: description(fields),
    associatedContact: associatedContact(),
    advanceNoticeMaintenance: advanceNoticeMaintenance(fields),
    operatingTimeMaintenance: operatingTimeMaintenance(fields),
    installationDate: installationDate(fields),
    operationEntryDate: operationEntryDate(fields, dates),
    totalOperationTime: totalOperationTime(fields),
    timeSinceLastMaintenance: timeSinceLastMaintenance(fields),
  };

  if (isUpdating) {
    return commonValidations;
  }

  return {
    ...commonValidations,
    situation: situation(),
    lastMaintenanceDate: lastMaintenanceDate(fields, dates),
    performedMaintenanceAmount: performedMaintenanceAmount(fields),
  };
};
